<template>
  <section id="section-offer">
    <div id="body-container">
      <div id="middle-container">
        <div class="wrapper">
          <div class="image left-img desktop-only">
            <img class="cards" :src="assets.left" alt="" />
          </div>
          <div id="text-container">
            <h6>
              <img class="star" :src="assets.starIcon" alt="" />
              {{ offerData.eyebrow }}
            </h6>
            <h1 v-html="offerData.h1"></h1>
            <h3 v-html="offerData.h3"></h3>
            <p v-html="offerData.body"></p>
            <p>
              <span class="bold">{{ offerData.join_text }}</span> <a :href="offerData.join_href">{{ offerData.join_label }}</a>
            </p>
            <a class="shop-gift-cards" :href="offerData.cta_href">{{ offerData.cta_label }}</a>
          </div>
          <div class="image right-img desktop-only">
            <img class="cards" :src="assets.right" alt="" />
          </div>
        </div>
        <p class="description" v-html="offerData.legal"></p>
      </div>
      <div class="top-bar desktop-only">
        <img :src="assets.loyaltyBar" alt="" />
      </div>
    </div>
  </section>
</template>

<script>
import config from 'config';

const BASE_ASSETS = config.baseAssetsUrl;

export default {
  name: 'SectionOffer',

  props: {
    offerData: {
      type: Object,
      required: true,
    },
  },

  computed: {
    assets() {
      const img = this.offerData.images;
      const base = `${BASE_ASSETS}/section-offer`;
      return {
        left:        `${base}/${img.left}`,
        right:       `${base}/${img.right}`,
        loyaltyBar:  `${base}/${img.loyalty_bar}`,
        starIcon:    `${base}/${img.star_icon}`,
      };
    },
  },
};
</script>

<style lang="scss">
#campaign section#section-offer {
  * {
    box-sizing: border-box;
    color: #fff !important;
  }

  @media only screen and (max-width: 767px) {
    .desktop-only {
      display: none !important;
    }
  }

  #body-container {
    position: relative;
    background-image: url('https://storage.googleapis.com/assets.mcomnyapps.net/gift-card-rewards/2025-12/images/banner_bg.jpg');
    background-size: 100%;
    width: 100%;
    max-width: 1607px;
    margin: auto;
    background-repeat: no-repeat;
    height: auto !important;

    @media only screen and (min-width: 768px) {
      aspect-ratio: 1607 / 575;
    }

    @media only screen and (max-width: 767px) {
      aspect-ratio: 375 / 545;
      background-image: url('https://storage.googleapis.com/assets.mcomnyapps.net/gift-card-rewards/2025-12/images/banner_bg_m.jpg');
    }

    #middle-container {
      position: relative;
      padding-top: clamp(36px, 3.7vw, 60px);
      height: 100%;
      flex-direction: column;

      @media only screen and (max-width: 767px) {
        padding-bottom: 3em;
      }

      @media only screen and (min-width: 768px) {
        .wrapper {
          display: flex;
        }
      }

      .image {
        background-image: none;
        padding-top: 0;
      }

      .left-img {
        flex: 1;
        margin-top: clamp(-86px, -5.4vw, -20px);

        img {
          width: calc(436 / 1607 * 100vw);
          max-width: 436px;
          margin-left: 5px;
          margin-right: auto;
          display: block;
        }
      }

      #text-container {
        width: 680px;
        text-align: center;
        padding: 0;

        @media only screen and (max-width: 750px) {
          width: 100%;
        }

        h6 {
          flex: 1 1 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: 'Macys Sans Bold', sans-serif;
          font-weight: normal;
          font-size: 18px;
          z-index: 1;

          @media only screen and (max-width: 767px) {
            font-size: 15px;
            margin-bottom: calc(8 / 375 * 100vw);
          }

          .star {
            display: inline-block;
            margin: 0 3px 0 0;
            width: 25px;
            height: 25px;
            flex-shrink: 0;

            @media only screen and (max-width: 1600px) and (min-width: 768px) {
              width: calc(25 / 1600 * 100vw);
              height: calc(25 / 1600 * 100vw);
              margin: 0 calc(3 / 1600 * 100vw) 0 0;
            }

            @media only screen and (max-width: 767px) {
              width: calc(15 / 375 * 100vw);
              height: calc(14 / 375 * 100vw);
            }
          }
        }

        h1 {
          font-size: clamp(30px, 3.16vw, 51px);
          padding-top: clamp(10px, 2.7vw, 42px);
          line-height: 1.1;
          font-family: 'TT Ramillas Bold', sans-serif;
        }

        h3 {
          font-family: 'Macys Sans Medium', arial, sans-serif;
          font-weight: normal;
          font-size: clamp(21px, 2vw, 32px);
          margin-top: 0;
          letter-spacing: -0.7px;
          line-height: 1.3;

          @media only screen and (max-width: 767px) {
            line-height: 1.1;
          }
        }

        a {
          text-decoration: underline !important;
        }

        p {
          font-size: 15px;
          line-height: 1.15;

          .bold {
            font-family: 'Macys Sans Bold', sans-serif;
          }

          @media only screen and (max-width: 767px) {
            font-size: 12px;
            line-height: 1.4;

            .smaller {
              font-size: 10px;
            }
          }

          &:nth-of-type(1) {
            margin-top: 11px;
            width: auto;
          }

          &:nth-of-type(2) {
            margin-top: clamp(12px, 1.24vw, 20px);
            margin-bottom: 12px;
          }
        }

        .shop-gift-cards {
          display: block;
          position: relative;
          left: -1.2vw;
          font-size: 15px;
          width: 125px;
          line-height: 2.3;
          margin: 0 auto;

          @media only screen and (min-width: 1600px) {
            left: -20px;
          }

          @media only screen and (max-width: 767px) {
            margin-top: -8px;
            font-size: 12px;
          }
        }
      }

      .right-img {
        flex: 1;
        margin-top: clamp(-114px, -7.7vw, -40px);

        img {
          width: calc(455 / 1607 * 100vw);
          max-width: 455px;
          position: relative;
          margin-left: auto;
          margin-right: 30px;
        }
      }
    }

    .description {
      width: 90%;
      margin: 0 auto;
      text-align: center;
      transform: none;
      font-size: 10px;
      max-width: 700px;
      padding-top: 10px;
      line-height: 1.2;

      @media only screen and (max-width: 767px) {
        font-size: calc(10 / 375 * 100vw);
        padding-top: calc(10 / 375 * 100vw);
        padding-bottom: calc(16 / 375 * 100vw);
        width: 94%;
        position: absolute;
        bottom: 0;
        margin-left: 3%;
      }

      @media only screen and (min-width: 1600px) {
        padding: 0;
        padding-top: 10px;
      }
    }

    .top-bar {
      position: absolute;
      top: 0;

      img {
        width: 100%;
        margin-top: -8px;
      }
    }

    @media only screen and (min-width: 768px) and (max-width: 1370px) {
      #middle-container {
        padding-top: clamp(36px, 2.4vw, 52px);

        #text-container h1 {
          padding-top: clamp(10px, 1.6vw, 37px);
        }
      }

      .description {
        margin-top: clamp(10px, 1.8vw, 36px);
      }
    }

    @media only screen and (min-width: 768px) and (max-width: 1024px) {
      #middle-container {
        padding-top: clamp(20px, 2.6vw, 52px);

        #text-container {
          padding-top: clamp(5px, 0.5vw, 20px);

          h1 {
            padding-top: clamp(5px, 0.5vw, 37px);
          }

          h6 {
            white-space: nowrap;
          }

          p {
            font-size: 14px;

            &:nth-of-type(2) {
              margin-top: clamp(5px, 0.5vw, 20px);
              margin-bottom: clamp(5px, 0.5vw, 20px);
            }
          }

          .shop-gift-cards {
            line-height: 1.5;
          }
        }
      }

      .description {
        margin-top: 0;
      }
    }
  }
}

body.inapp #campaign section#section-offer {
  #middle-container #text-container {
    .shop-gift-cards {
      display: none;
    }

    .shop-gift-cards-inapp {
      display: block;
    }
  }
}
</style>
